import { FlexColumn } from "@similarweb/ui-components";

import { SWReactTable } from "app/components/React/Table/SWReactTable";
import { translate } from "app/filters/i18nFilter";
import { sharedAutomationKeys } from "app/pages/activation/components/Widget/dataAutomationKeys";
import { textKeys } from "app/pages/activation/components/Widget/texts";

import * as SC from "./styles";

export const TableLoadingState = ({ rows = 4 }: { rows?: number }) => (
    <FlexColumn data-automation={sharedAutomationKeys.tableLoader}>
        <SC.LoadingTableHeaderContainer>
            <SC.LoadingTableItem>{translate(textKeys.domain)}</SC.LoadingTableItem>
            <SC.Spacer />
            <SC.LoadingTableItem>{translate(textKeys.trafficShare)}</SC.LoadingTableItem>
            <SC.LoadingTableItem>{translate(textKeys.wow)}</SC.LoadingTableItem>
        </SC.LoadingTableHeaderContainer>

        <SWReactTable
            tableColumns={[]}
            tableData={{ Data: [] }}
            disableRowHover
            type="regular"
            isLoading
            loaderRowsNumber={rows}
        />
    </FlexColumn>
);
